<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div mat-dialog-title>
    <div class="flex flex-row justify-between">
      <div>
        {{ data.fileName }}
        <span class="text-gray-600 text-xs" *ngIf="data.createdAt">{{ data.createdAt | standardDate }}</span>
      </div>
      <button mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <img
      [src]="data.url"
      class="transform"
      style="max-height: 100vh; max-width: 100vw"
      [ngClass]="{
        'rotate-0': rotate === 0,
        'rotate-90': rotate === 1,
        'rotate-180': rotate === 2,
        '-rotate-90': rotate === 3
      }"
    />
  </mat-dialog-content>
  <div mat-dialog-actions class="flex flex-row justify-center items-center">
    <button mat-icon-button class="bg-blue-500 text-white" (click)="rotateCounterClockWise()">
      <mat-icon>rotate_left</mat-icon>
    </button>
    <button mat-icon-button class="bg-blue-500 text-white" (click)="rotateClockWise()">
      <mat-icon>rotate_right</mat-icon>
    </button>
    <a [href]="data.url" target="_blank" class="bg-blue-500 text-white" mat-icon-button>
      <mat-icon>arrow_downward</mat-icon>
    </a>
  </div>
</div>
